var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "rating-badge d-inline-flex align-center gc-1 py-1 px-2 rounded bg-gray-40",
      attrs: { "data-qa": "stars_rate" },
    },
    [
      _c("span", {
        staticClass:
          "ui-icon-rating-star-filled ui-icon-fz-medium rating--text flex-shrink-0",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-subtitle-1 text--text text-no-wrap" }, [
        _vm._v(
          "\n    " + _vm._s(_setup.formatRatingScore(_vm.solidity)) + "\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }